function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import { Menu } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import Common from "../includes/Common";
import { Power, HouseFill, FolderFill, Eyeglasses, CashStack, BoxSeamFill, Speedometer, Clipboard2PulseFill, Building, PeopleFill, GearFill, EyeFill, Tools, Capsule, SlashSquareFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SubMenu = Menu.SubMenu;
var UserNavBar = function UserNavBar(_ref) {
  var handleMenuClose = _ref.handleMenuClose;
  var navigate = useNavigate();
  var _useState = useState('day'),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var handleClick = function handleClick(e) {
    setCurrent(e.key);
    if (e.key == 'quit') {
      axios.post(Common.baseApiUrl + 'sulogout').then(function (response) {
        if (response.data.status == 200) {
          localStorage.clear();
          navigate('/');
        }
      })["catch"](function (error) {});
    }
    handleMenuClose();
  };
  var user = Common.currentUser;
  return /*#__PURE__*/_jsxs(Menu, {
    onClick: handleClick,
    style: {
      background: "#3B819C"
    },
    selectedKeys: current,
    theme: "dark",
    mode: "vertical",
    children: [(Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Speedometer, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/dashboard",
        children: "Tableau de bord"
      })
    }, "dash"), (Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 11 || Common.currentUser.role == 71 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(HouseFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/cashier",
        children: "Accueil"
      })
    }, "day"), (Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 21 || Common.currentUser.role == 22 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Clipboard2PulseFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/consultations",
        children: "Consultations"
      })
    }, "chech"), (Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 31 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(EyeFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/laboratoire",
        children: "Exploration"
      })
    }, "lab"), (Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 41 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Capsule, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/pharmacie",
        children: "Pharmacie"
      })
    }, "pha"), (Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 41 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Eyeglasses, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/lunetterie",
        children: "Lunetterie"
      })
    }, "lun"), (Common.currentUser.role == 201 || Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 71 || Common.currentUser.role == 51 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Tools, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/chirurgie",
        children: "Chirurgie"
      })
    }, "chir"), (Common.currentUser.role == 201 || Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 71 || Common.currentUser.role == 61 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(SlashSquareFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/laser",
        children: "Laser"
      })
    }, "las"), (Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 71 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(CashStack, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/facturation",
        children: "Facturation"
      })
    }, "fact"), (Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 71 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Building, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/companies",
        children: "Soci\xE9t\xE9s"
      })
    }, "comps"), (Common.currentUser.role == 71 || Common.currentUser.role == 41 || Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(FolderFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/departments",
        children: "Services"
      })
    }, "Depts"), (Common.currentUser.role == 201 || Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(BoxSeamFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/consumables",
        children: "Consommables"
      })
    }, "cons"), (Common.currentUser.role == 91 || Common.currentUser.role == 81 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(PeopleFill, {
        style: {
          color: 'FBB91D'
        },
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/users",
        children: "Utilisateurs"
      })
    }, "users"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(GearFill, {
        style: {
          color: 'FBB91D'
        },
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/accountconfig",
        children: "Compte"
      })
    }, "accountconfig"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Power, {
        style: {
          color: 'EA696B',
          fontWeight: "bold"
        },
        size: 26
      })
    }, "quit")]
  });
};
export default UserNavBar;